import { useSelector } from "react-redux";

/**
 * Recupera o estado de autenticação atual do usuário no Redux.
 *
 * @description
 * Este hook realiza as seguintes operações:
 * 1. Lê `isLoggedIn` e `statusToken` da store `auth`
 * 2. Deriva `isAuthorized` com base no login e na validade do token
 *
 * @returns {Object} Objeto com os dados de autenticação
 * @returns {boolean} returns.isLoggedIn Indica se existe sessão autenticada
 * @returns {string} returns.statusToken Status atual do token de autenticação
 * @returns {boolean} returns.isAuthorized Indica se o usuário está autenticado com token válido
 */
function useAuth() {
  const { isLoggedIn, statusToken } = useSelector((store) => store.auth);
  const isAuthorized = isLoggedIn && statusToken === "valid";

  return { isLoggedIn, statusToken, isAuthorized };
}

export default useAuth;
